import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "./module_auth/AuthService";
import { useNavigate } from "react-router-dom";
import { GridPerson } from './component/common/GridPerson';
import { GridJob } from './component/common/GridJob';
import { GridTalent } from './component/talent/GridTalent';
import { NewsCard } from "./component/NewsCard"
import { BlogCard } from "./component/BlogCard"
import { CmtyBaseTableRow } from './component/community/CmtyBaseTableRow';
import { MapHome } from './component/map/MapHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faClock, faUser, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import './App.css'
import { useLocation } from "react-router-dom";
import { sendGoogleAnalytics } from './component/common/BaseUtil';
import Select from 'react-select'
import { Helmet } from 'react-helmet';

export function Home() {
    const location = useLocation();

    const [jobList, setJobList] = useState([]);
    const [personList, setPersonList] = useState([]);

    const [premiumJobList, setPremiumJobList] = useState([]);
    const [premiumPersonList, setPremiumPersonList] = useState([]);
    const [gridPersonObjectList, setGridPersonObjectList] = useState([]);
    const [premiumTalentList, setPremiumTalentList] = useState([]);
    const [newsList, setNewsList] = useState([]);
    const [blogList, setBlogList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [jobPostList, setJobPostList] = useState([]);
    const [visaPostList, setVisaPostList] = useState([]);
    const [langPostList, setLangPostList] = useState([]);
    const [studyPostList, setStudyPostList] = useState([]);
    const [emailSubscription, setEmailSubscription] = useState([]);

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        getCityList();

        const searchObject = {
            searchInput: "",
        }
        //premium jobs
        // fetch(basePort + '/get/premium/search/jobs',
        //     { method: 'post', headers, body: JSON.stringify(searchObject) })
        //     .then(response => response.json())
        //     .then(response => {
        //         setPremiumJobList(response)
        //     }).catch(error => console.log(error))

        //premium persons
        // fetch(basePort + '/get/premium/search/persons',
        //     { method: 'post', headers, body: JSON.stringify(searchObject) })
        //     .then(response => response.json())
        //     .then(response => {
        //         setPremiumPersonList(response)
        //         makeGridPersonArray(response)

        //     }).catch(error => console.log(error))

        //premium talents
        fetch(basePort + '/get/premium/search/talent',
            { method: 'post', headers, body: JSON.stringify(searchObject) })
            .then(response => response.json())
            .then(response => {
                setPremiumTalentList(response)
            }).catch(error => console.log(error))

        //normal jobs @deprecated
        // fetch(basePort + '/get/search/jobs/1',
        //     { method: 'post', headers, body: JSON.stringify(searchObject) })
        //     .then(response => response.json())
        //     .then(response => {
        //         setJobList(response.cardList)
        //     }).catch(error => console.log(error))

        //normal persons @deprecated
        // fetch(basePort + '/get/search/persons/1',
        //     { method: 'post', headers, body: JSON.stringify(searchObject) })
        //     .then(response => response.json())
        //     .then(response => {
        //         setPersonList(response.cardList)
        //     }).catch(error => console.log(error))

        //news list @deprecated
        // fetch(basePort + '/get/news/list/1',
        //     {
        //         method: 'GET', headers,
        //         body: JSON.stringify()
        //     })
        //     .then(response => response.json())
        //     .then(response => {
        //         setNewsList(response.cardList)
        //     }).catch(error => console.log(error))

        //blogs list
        fetch(basePort + '/get/blogs/1',
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setBlogList(response.cardList)
            }).catch(error => console.log(error))

        //cmty @deprecated
        // fetch(basePort + '/get/home/cmty/posts',
        //     {
        //         method: 'GET', headers,
        //         body: JSON.stringify()
        //     })
        //     .then(response => response.json())
        //     .then(response => {
        //         setJobPostList(response.jobPostList)
        //         setVisaPostList(response.visaPostList)
        //         setLangPostList(response.langPostList)
        //         setStudyPostList(response.studyPostList)
        //     }).catch(error => console.log(error))
    }, []);

    function getCityList() {
        let url = basePort + '/get/config'
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCityList(response.cityEntityList)
            }).catch(error => console.log(error))
    }

    function makeGridPersonArray(objectList) {
        let gridObjectList = []
        for (let i = 0; i < objectList.length; i++) {
            let gridArray = []
            let index = parseInt(i / 3)
            if (i % 3 === 0) {
                if (objectList[i]) {
                    gridArray.push(objectList[i])
                }
                if (objectList[i + 1]) {
                    gridArray.push(objectList[i + 1])
                }
                if (objectList[i + 2]) {
                    gridArray.push(objectList[i + 2])
                }
                gridObjectList.push(gridArray)
            }
        }
        setGridPersonObjectList(gridObjectList)
    }

    let navigate = useNavigate();
    function backToPersonList() {
        let url = "/person_list?page=1";
        navigate(url);
    }

    function backToJobList() {
        let url = "/job_list?page=1";
        navigate(url);
    }

    function backToNewsList() {
        let url = "/news_list?page=1";
        navigate(url);
    }

    function backToBlogList() {
        let url = "/blog_list?page=1";
        navigate(url);
    }

    function backToCmtyHome() {
        let url = "/cmty_home";
        navigate(url);
    }

    return (
        <div>
            <Helmet>
                {/* 기본 Meta */}
                <title>지워커 | 독일 한인 지도·전문가·생활정보 플랫폼</title>
                <meta name="description" content="독일 거주 한인을 위한 필수 생활 정보 플랫폼! 한인지도, 엄선된 한인전문가 프로필, 현지 생활·정착 블로그 정보를 한눈에 확인하세요." />
                <meta name="keywords" content="지워커, gworker, 독일 한인 지도, 독일 한인 전문가, 독일 한인업소, 독일 생활 정보, 독일 한인 블로그" />
                <meta name="robots" content="index,follow" />
                <link rel="canonical" href="https://www.g-worker.co.kr/" />

                {/* Open Graph (SNS 공유용) */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="지워커 (G-Worker)" />
                <meta property="og:title" content="지워커 | 독일 한인 지도·전문가·생활정보 플랫폼" />
                <meta property="og:description" content="독일 거주 한인을 위한 필수 생활 정보 플랫폼! 한인지도, 엄선된 한인전문가 프로필, 현지 생활·정착 블로그 정보를 한눈에 확인하세요." />
                <meta property="og:image" content="https://www.g-worker.co.kr/gworker_logo.jpg" />
                <meta property="og:url" content="https://www.g-worker.co.kr/" />
                <meta property="og:locale" content="ko_KR" />
            </Helmet>
            <main class="page lanidng-page">
                {/* <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>독일뉴스</p>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div className="dynamic-list">
                            {newsList.map((object, index) => (
                                <article key={index}>
                                    <NewsCard object={object} index={index} />
                                </article>
                            ))}
                        </div>
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{ margintop: '10px' }}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToNewsList}>뉴스 더보기</a></li>
                        </ul>
                    </nav>
                </section> */}

                <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>독일 한인 지도</p>
                            </div>
                        </div>
                    </div>
                    <div class="container" style={{ marginBottom: '20px' }}>
                        <MapHome compactLayout />
                    </div>
                </section>

                {/* <section>
                    <div class="container" style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>커뮤니티</p>
                            </div>
                        </div>
                    </div>

                    <div class="container">
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_job?page=1">취업 <FontAwesomeIcon icon={faPlus} /></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{ width: '150px' }}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index} />
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_visa?page=1">비자 <FontAwesomeIcon icon={faPlus} /></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{ width: '150px' }}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visaPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_lang?page=1">어학 <FontAwesomeIcon icon={faPlus} /></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{ width: '150px' }}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {langPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_study?page=1">유학 <FontAwesomeIcon icon={faPlus} /></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{ width: '100px' }}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{ width: '150px' }}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {studyPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{ margintop: '10px' }}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToCmtyHome}>커뮤니티 더보기</a></li>
                        </ul>
                    </nav>
                </section> */}

                {/* <section>
                    <div class="container" style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>채용정보</p>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        {premiumJobList.length > 0 && (
                            <div class="row">
                                <GridJob object={premiumJobList} cityList={cityList} />
                            </div>
                        )}
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{ margintop: '10px' }}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToJobList}>채용 더보기</a></li>
                        </ul>
                    </nav>
                </section> */}

                <section>
                    <div class="container" style={{ marginTop: '50px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>독일 한인 전문가</p>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <ol className="breadcrumb"><li className="breadcrumb-item"><span>프리미엄</span></li></ol>
                        {premiumTalentList.length > 0 && (
                            <div className="row">
                                <GridTalent object={premiumTalentList} cityList={cityList} />
                            </div>
                        )}
                    </div>
                </section>

                <section>
                    {/* <div class="container" style={{ marginTop: '10px', marginBottom: '10px' }}> */}
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>블로그</p>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div className="dynamic-list">
                            {blogList.map((object, index) => (
                                <article key={index}>
                                    <BlogCard object={object} index={index} />
                                </article>
                            ))}
                        </div>
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{ margintop: '10px' }}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToBlogList}>블로그 더보기</a></li>
                        </ul>
                    </nav>
                </section>

                {/* <section>
                    <div class="container" style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col" style={{ textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px' }}>인재정보</p>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        {gridPersonObjectList.map((object, index) => (
                            <div class="row">
                                <GridPerson object={object} cityList={cityList} />
                            </div>
                        ))
                        }
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{ margintop: '10px' }}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToPersonList}>인재 더보기</a></li>
                        </ul>
                    </nav>
                </section> */}

                {/* 🚨 Job Scam Alert Banner Image */}
                <div className="w-100">
                    <img
                        src="/assets/img/daeguWesternDistrict/jobScamAlertBanner.jpg"
                        alt="취업사기 주의 (Job Scam Alert)"
                        className="img-fluid"
                        style={{
                            width: '200px',        // 🔹 고정 너비
                            height: '200px',       // 🔹 고정 높이
                            objectFit: 'contain',  // 이미지 비율 유지
                            display: 'block',
                            margin: '10px auto',
                            borderRadius: '6px',
                        }}
                    />
                </div>
            </main>
        </div>
    );
}